export const ATTENDANCE_OPTIONS = [
  { value: "ATTENDED", label: "Attended" },
  { value: "NOSHOW", label: "No Show" },
  { value: "LMC", label: "LMC" },
  { value: "TBC", label: "TBC" }
];

// Mirrors the partner dashboard status palette exactly.
export const STATUS_COLORS = {
  NEW: "#b5b5b5",
  ATTENDED: "#5daf50",
  NOSHOW: "#f44336",
  LMC: "#e67e22",
  TBC: "#8e44ad",
  CANCELED: "#f44336"
};

export const labelFor = (status) => ATTENDANCE_OPTIONS.find((o) => o.value === status)?.label || status;

export const statusHex = (status) => STATUS_COLORS[status] || STATUS_COLORS.NEW;

export const isMarked = (status) => Boolean(status) && status !== "NEW";

// A booking's accent reflects the strongest attendance signal among its clients:
// any no-show/late flags it red, an all-attended session reads green, and
// anything still pending returns null so callers fall back to the brand colour.
export function accentFor(clients) {
  if (!clients?.length) return null;
  if (clients.some((c) => c.status === "NOSHOW" || c.status === "LMC")) return STATUS_COLORS.NOSHOW;
  if (clients.every((c) => c.status === "ATTENDED")) return STATUS_COLORS.ATTENDED;
  return null;
}
